import { useRouter } from '@uirouter/react';
import { useImmerAtom, useSetImmerAtom } from 'jotai-immer';
import { ROUTE_CREATE, ROUTE_UPDATE } from '../../groups_const';
import { PageStoreHook, GroupsDataItem } from '../groups_list_types';
import { pageStateAtom } from '../groups_list_atoms';
import { useCallback, useEffect } from 'react';
import useNgContext from '../../../../core/services/useNgContext';
import { pageStateGroupsCreateAtom } from '../../create/groups_create_atoms';

export const useGroupsListStore = (): PageStoreHook => {
    const router = useRouter();
    const ctx = useNgContext();
    const [state, setState] = useImmerAtom(pageStateAtom);
    const setEditState = useSetImmerAtom(pageStateGroupsCreateAtom);

    const routeToCreate = useCallback(() => {
        router.stateService.go(ROUTE_CREATE);
        setEditState(draft => {
            draft.mode = 'CREATE';
            draft.id = '';
        });
    }, [router.stateService, setEditState]);

    const routeToEdit = useCallback(
        (rowItem: GroupsDataItem) => {
            // the shape of the get request for update is different than this.
            router.stateService.go(ROUTE_UPDATE, { Id: rowItem.Id });
            setEditState(draft => {
                draft.mode = 'UPDATE';
                draft.id = rowItem.Id;
            });
        },
        [router.stateService, setEditState],
    );

    useEffect(() => {
        setState(draft => {
            draft.canEdit = ctx.User?.Type === 'VERITYSA';
            return draft;
        });
    }, [ctx.User?.Type, setState]);

    return {
        canEdit: state.canEdit,
        routeToCreate,
        routeToEdit,
    };
};
